import React from 'react';
import './Concept.css';
import dec_img from '../../img/main/bg.gif'
import { Link } from "react-scroll";

const Concept = () => {
    return (
        <div className="concept-wrap" id='concept'>
            <div className="container concept">
                <h2 className='concept-title colorful'>Idea and concept of this event</h2>
                <div className="concept-content">
                    <div className='concept-content_main'>
                        <img className="concept-img concept-item" src={dec_img} alt="" />
                        <div className='concept-text--block concept-item'>
                            <p className="concept-text p1">Hey, fellow marketers! You can't keep grinding like it's the 90s anymore. You gotta jump on that AI train, or you're gonna be left in the dust. But don't worry, we got you covered with our online conference, featuring top-tier voices dropping some knowledge bombs in killer talks and panel discussions. We've got a stacked lineup of 10+ speakers, along with a panel discussion, startup spotlights, Q&A sessions, certificates, and some spicy chats in the event forum.</p>
                            <p className="concept-text p1">We're talking global reach here, with over 1000 participants expected to join from all corners of the planet. And you know this event is legit because we're backed by an event organizer that's been crushing it with over 50 successful events in the past three years.</p>
                            <p className="concept-text p1">Our speakers are the real deal too - we're talking award-winning experts from the biggest brands who are ready to share their fresh use cases and secrets to success.</p>
                            <p className="concept-text p1">Plus, we're hooking you up with certificates to show off your new skills and knowledge.</p>
                            <p className='concept-text concept-text--bold p1'>So, if you're serious about staying ahead of the curve with the latest AI tools in marketing, you gotta hit that button and join our community-driven conference. Let's make moves and level up our game together!</p>
                            <p className='concept-text concept-text--bold p1'>And don't forget about the certificates - we got you covered, fam!</p>
                            <Link
                                activeClass="active"
                                to='tickets'
                                spy={true}
                                smooth={true}
                                offset={-94}
                                className='concept-btn button'
                            >
                                Join
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Concept;